<div id="managesubscriptiondetails" class="subBlockContainer managesubscriptiondetails">
    <div class="subBlockContent">
        <div class="title-wrapper">
            <div class="page-title-wrapper">
                <div class="title blade-title-font">
                    {{details?.customer?.out_company_name}} Details
                </div>
                <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
                <img class="page-title-img" [src]="details?.annuityType?.logo">
            </div>

        </div>
        <div style="background: #ededed;">
            <div class="inner-subBlock-wrapper">
                <!-- <div class="page-title-wrapper">
                    <div class="title blade-title-font">
                        {{details?.customer?.out_company_name}} Details
                    </div>
                    <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
                    <img class="page-title-img" [src]="details?.annuityType?.logo">
                </div> -->

                <!-- <div class="row filter-wrapper" style="margin-top: -25px;">
          <div class="col-md-10">
            <small
              class="header-description header-description-grey">{{ details?.annuityType?.longDescription }}</small>
          </div>
          <div class="col-md-2 small-logo">
            <img [src]="details?.annuityType?.logo">
          </div>
        </div> -->
                <!-- <div class="top-divider"></div> -->
                <div class="wrapper center-block">
                    <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                        <div class="panel panel-default">
                            <div class="panel-heading active" role="tab" id="headingOne">
                                <h4 class="panel-title">
                                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    END USER DETAILS
                    <span class="panel-subtitle" id="panelsubtitle">
                      <label class="lable-title">NAME:&nbsp;</label> {{ details?.customer?.out_company_name }}
                      <label class="lable-title">| STATUS:&nbsp;</label> {{ details?.customer?.out_status_desc }}
                      <span class="triangle-down"></span>
                    </span>
                  </a>
                                </h4>
                                <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                    <div class="panel-body">
                                        <div class="panel-content">
                                            <div class="row">
                                                <div class="col-sm">
                                                    <label class="lable-title">NAME</label>
                                                    <p class="paragraph-text">{{ details?.customer?.out_company_name }}</p>
                                                </div>
                                                <div class="col-sm">
                                                    <label class="lable-title">FIRST AND LAST NAME</label>
                                                    <p class="paragraph-text">{{ details?.customer?.out_first_name }} {{ details?.customer.out_last_name }}</p>
                                                </div>
                                                <div class="col-sm">
                                                    <label class="lable-title text-red">STATUS</label>
                                                    <p class="paragraph-text">{{ details?.customer?.out_status_desc }}</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm">
                                                    <label class="lable-title">END USER DESCRIPTION</label>
                                                    <p class="paragraph-text">{{ details?.customer?.out_tenant_desc }}</p>
                                                </div>
                                                <div class="col-sm">
                                                    <label class="lable-title">PHONE</label>
                                                    <p class="paragraph-text">{{ details?.customer?.out_phone }}</p>
                                                </div>
                                                <div class="col-sm">
                                                    <label class="lable-title">NEXT BILLING DATE</label>
                                                    <p class="paragraph-text">{{ details?.customer?.out_next_billing_date }}</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm">
                                                    <label class="lable-title">EMAIL</label>
                                                    <p class="paragraph-text">{{ details?.customer?.out_email }}</p>
                                                </div>
                                                <div class="col-sm">
                                                    <label class="lable-title">ADDRESS</label>
                                                    <p class="paragraph-text" class="paragraph-text">{{ details?.customer?.out_address_1 }} {{ details?.customer.out_address_2 }} {{ details?.customer?.out_address_3 }}</p>
                                                    <p class="paragraph-text">{{ details?.customer?.out_city}}, {{ details?.customer?.out_region }} {{ details?.customer?.out_post_code }}</p>
                                                </div>
                                                <div class="col-sm">

                                                </div>
                                            </div>
                                            <div class="row" *ngIf="details?.customer.out_customer_id && showCancelContract">
                                                <button id="btnCancelContract" class="button btn-dark button-small" [ngbPopover]="popContent" popoverTitle="Cancel Contract" #p="ngbPopover" placement="bottom">CANCEL CONTRACT</button>

                                                <ng-template #popContent>
                                                    <p>Are you sure you want to cancel the contract?</p>
                                                    <div class="col align-center">
                                                        <button class="button-hover-white" (click)="[p.close(), cancelContract()]">Yes</button>
                                                        <button class="button-hover-white" (click)="p.close()">No</button>
                                                    </div>
                                                </ng-template>
                                            </div>

                                            <!-- Paymen Detail Section-->
                                            <app-subscription-payment-detail [paymentMethod]="paymentMethod" [digitalWalletId]="details?.customer?.out_digital_wallet_id"></app-subscription-payment-detail>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading-screen *ngIf="!loadContent" [scrollAfterLoading]="true" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>

        <div class="inner-subBlock-content" *ngIf="loadContent">
            <div class="inner-subBlock-wrapper" *ngIf="!subscriptions?.length && !newOrderItems?.length">
                <div class="noData-wrapper">
                    <div>
                        <img src="../../images/new_ui/no-subscription.png">
                    </div>
                    <label class="noData-label">
            We couldn't find any <br />
            subscriptions for this tenant
          </label>
                    <br />
                    <div *ngIf="hasPurchaseAccess">
                        <button class="button button-red button-large btn-long" (click)="getSubscriptionOrderList();">Add new
              subscription</button>
                    </div>

                </div>
            </div>
            <div class="inner-subBlock-wrapper" *ngIf="(subscriptions?.length || newOrderItems.length) && !(programType == 'CSP') ">
                <div class="row filter-wrapper" style="margin-top: 20px;">
                    <div class="col-md-3">
                        <div class="searchInputGroup">
                            <div class="searchIcon">
                                <img src="../../images/new_ui/filter.png">
                            </div>
                            <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                        </div>
                    </div>
                    <!-- <div class="col-md-3">
               <div class="dropdown">
                   <button class="btn btn-dropdown dropdown-toggle" type="button" id="btnStatus" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     {{ currentStatus }}
                   </button>
                   <div class="dropdown-menu" aria-labelledby="btnStatus">
                     <a class="dropdown-item drp-status" (click)="sortByStatus('Active');">Active</a>
                     <a class="dropdown-item drp-status" (click)="sortByStatus('Cancelled Tenant');">Cancelled Tenant</a>
                     <a class="dropdown-item drp-status" (click)="sortByStatus('Error');">Error</a>
                     <a class="dropdown-item drp-status" (click)="sortByStatus('Pending Entry');">Pending Entry</a>
                   </div>
                 </div>
           </div> -->

                    <div class="col-md-3">
                        <mat-form-field>
                            <mat-select placeholder="Status">
                                <mat-option value="active" (click)="sortByStatus('Active');">
                                    ACTIVE
                                </mat-option>
                                <mat-option value="pending" (click)="sortByStatus('Cancelled Tenant');">
                                    PENDING CHANGES
                                </mat-option>
                                <mat-option value="Error" (click)="sortByStatus('Error');">
                                    Error
                                </mat-option>
                                <mat-option value="Pending Entry" (click)="sortByStatus('Pending Creation');">
                                    Pending Entry
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="shared-outer-wrapper">
                    <div *ngIf="newOrderItems.length > 0 || confirmRequired" class="align-right top-bottom-space confirm-all-warning" style="display: table;">
                        <div>
                            <div style="width: 2%; float: left;" class="info-icon info-icon-red"></div>
                            <div class="align-left" style="float:left">Proration will be applied for eligible stock codes added in middle of billing period</div>
                            <div>Please click Confirm All to save changes</div>
                        </div>
                    </div>
                    <table class="table display-block">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 57%">DESCRIPTION</th>
                                <th scope="col" class="align-center" style="width: 10%">QTY</th>
                                <th scope="col" class="align-center" style="width: 10%">PRICE</th>
                                <th scope="col" class="align-right" style="width: 10%">TOTAL</th>
                                <th scope="col" class="align-center" style="width: 16%">STATUS</th>
                                <th scope="col" class="align-center" style="width: 3%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let subscription of sortedSubscriptions | TableFilterMultiple: ['out_stk_description', 'out_stock_code', 'out_sub_description', 'out_billing_freq_desc','out_price','out_status_desc'] : searchField">
                                <tr>
                                    <td style="position:relative" class="description-td">
                                        <span class="description">{{subscription?.out_stk_description}}</span>
                                        <div class="result-info">
                                            <div class="produc-secondary-title-wrapper">
                                                <span class="light-text">STOCK CODE:&nbsp;</span>
                                                <span>{{subscription?.out_stock_code}}</span>
                                                <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                <span class="light-text">REFERENCE:&nbsp;</span>
                                                <span>{{subscription?.out_sub_description}}</span>
                                                <div class="result-info">
                                                    <span class="light-text">BILLING:&nbsp;</span>
                                                    <span class="bold-text">{{subscription?.out_billing_freq_desc}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="align-right" style="position: relative;vertical-align: top;padding-right: 35px;">
                                        <div *ngIf="hasPurchaseAccess && subscription.out_status !=='XX' && subscription.out_status !== 'P' && !invalidTenant && !subscription.hasPendingError">
                                            <div class="qty-minus-sign button-red" [class.disableMinus]="subscription?.out_qty === '1'" (click)="increaseDecreaseQty(subscription, 'decrease')">
                                                <i class="fas fa-minus-square fa-2x"></i>
                                            </div>
                                            <input integerOnly type="text" class="input-box-small" [value]="subscription?.out_qty" (input)="onQtyChange(subscription?.out_stock_code, subscription?.out_price, 'existing', $event.target.value)" />
                                            <div class="qty-plus-sign button-red" (click)="increaseDecreaseQty(subscription, 'increase')">
                                                <i class="fas fa-plus-square fa-2x"></i>
                                            </div>
                                        </div>
                                        <div *ngIf="!hasPurchaseAccess || subscription.out_status ==='XX' || subscription.out_status === 'P' || invalidTenant && !subscription.hasPendingError">
                                            <label>{{ subscription?.out_qty }}</label>
                                        </div>
                                    </td>
                                    <td class="align-right">{{subscription?.out_price | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</td>
                                    <td class="align-right">{{ subscription?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                                    <td class="align-right">
                                        <label style="display:inline-block;">{{subscription?.out_status_desc}}</label>
                                        <div *ngIf="subscription?.actions?.length">
                                            <i [ngbTooltip]="subscription?.pendingChangeText" placement="bottom" class="master-tooltip info-icon info-icon-dark" style="display:inline-block;"></i>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <div *ngIf="hasPurchaseAccess && !invalidTenant">
                                            <button *ngIf="subscription.out_status === 'B' || subscription.out_status == ''" class="delete-button" (click)="deleteCurrentItem(subscription)" ngbTooltip="delete" placement="bottom"><i class="material-icons">delete</i></button>
                                            <button *ngIf="subscription.out_status === 'RS'" class="button button-red button-small button-hover-white" (click)="undoRemove(subscription?.out_stock_code, subscription?.originalStatus);">Undo</button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="newOrderItems">
                                <tr *ngFor="let order of newOrderItems">
                                    <td style="position:relative" class="description-td">
                                        <span class="description">{{order?.stockDescription}}</span>
                                        <div class="result-info">
                                            <div class="produc-secondary-title-wrapper">
                                                <span class="light-text">STOCK CODE:&nbsp;</span>
                                                <span>{{order?.stockCode}}</span>
                                                <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                                <span class="light-text">REFERENCE:&nbsp;</span>
                                                <input type="text" class="input-box sub-ref" [(ngModel)]="order.subscriptionDescription" />
                                                <div class="result-info">
                                                    <span class="light-text">BILLING:&nbsp;</span>
                                                    <span class="bold-text">{{ order?.billingFrequency }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <!-- <input integerOnly type="text" class="input-box-small order-qty" [(ngModel)]="order.qty" (input)="onQtyChange(order?.stockCode, order.price, 'new', $event.target.value)" /> -->
                                        <label>{{ order.qty }}</label>
                                    </td>
                                    <td class="align-center">{{order.price}}/mth</td>
                                    <td class="align-center">{{order.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                                    <td class="align-center">{{order.status}}</td>
                                    <td class="align-center">
                                        <button class="delete-button" ngbTooltip="delete" placement="bottom" (click)="removeOrder(order?.stockCode)"><i class="material-icons">delete</i></button>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                        <tfoot>
                            <div class="row totalPrice-wrapper">
                                <div class="col align-right">
                                    <span><b>Pending Total (incl GST) - </b> <span
                      style="font-size: 18px">{{ pendingTotal | currency:'AUD':'symbol-narrow':'.2-2' }}</span></span>
                                </div>
                                <div class="col align-left">
                                    <span><b>Active Total (incl GST) - </b> <span
                      style="font-size: 18px">{{ activeTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                                </div>
                            </div>
                        </tfoot>
                    </table>
                </div>
                <div class="row" style="position:relative">
                    <div class="col align-center button-margin" *ngIf="hasPurchaseAccess">
                        <button *ngIf="!invalidTenant" class="button button-red button-large button-margin-right" (click)="getSubscriptionOrderList();">Add new subscription</button>
                        <button class="button button-red button-large button-margin-left" [class.disable]="setDisabled" (click)="confirmChanges()">Confirm all</button>
                    </div>
                </div>
            </div>

        </div>


        <!-- Modal -->
        <div class="modal fade" id="addNewSubscriptiondetailsModdal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalLabel">Add items for order</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
                    </div>
                    <div class="modal-body">
                        <div class="row filter-wrapper" style="margin-left: 12px;">
                            <div class="col-md-4">
                                <div class="searchInputGroup">
                                    <div class="searchIcon">
                                        <img src="../../images/new_ui/filter.png">
                                    </div>
                                    <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchOrder">
                                </div>
                            </div>
                        </div>
                        <table class="table list-table description-table tbModal" style="width: auto;">
                            <thead>
                                <tr>
                                    <th scope="col" style="width:60%">DESCRIPTION</th>
                                    <th scope="col" class="align-center" style="width:15%">PRICE</th>
                                    <th scope="col" class="align-center" style="width:15%">QTY</th>
                                    <th scope="col" class="align-center" style="width:10%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of newSubscriptionItems | TableFilterMultiple: ['description', 'stockCode'] : searchOrder">
                                    <td style="position:relative" class="description-td">
                                        <span class="description">{{item?.description}}</span>
                                        <div class="result-info">
                                            <div class="produc-secondary-title-wrapper">
                                                <span class="light-text">STOCK CODE:&nbsp;</span>
                                                <span>{{item?.stockCode}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="align-center">{{item?.itemPrice}}/mth</td>
                                    <td class="align-center"><input integerOnly type="text" class="input-box-small" value="1" #orderquantity /></td>
                                    <td class="align-center">
                                        <button class="button button-red button-small button-hover-white" (click)="addNewOrders(item, orderquantity.value);">Add</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmPendingModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title pop-up-title" id="modalLabel">Confirm Pending Total</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
                    </div>
                    <div class="modal-body" style="margin:30px;">
                        <div>
                            <p>Your new Total is <b class="text-red">{{ pendingTotal | currency:'AUD':'symbol-narrow':'.2-2' }}</b> Variance Amount: <b class="text-red">{{ varianceAmount | currency:'AUD':'symbol-narrow':'.2-2' }}</b>
                            </p>
                            <br />
                            <p>
                                Once you have confirmed the order total noted above this request will be sent to Autodesk for verification and actioning. This portal will be automatically updated once Autodesk have confirmed your requested changes are live in their systems. Until this
                                confirmation is received, your Autodesk subscriptions will remain in their current state. If you have any questions regarding this process or the changes you are applying, please contact your Dicker Data representative.
                            </p>
                        </div>
                        <br />
                        <div>
                            <button class="btn btn-long btn-middle" data-toggle="modal" (click)="confirmPendingTotal()">Continue</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="updatedModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalLabel">Update Finish</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
                    </div>
                    <div class="modal-body" style="margin:30px;">
                        <div>
                            <p>
                                The following subscription commitments have been updated in the Dicker Data Portal, until these changes have been successfully confirmed by Autodesk you will not be billed for new services and the subscriptions will show on our portal with a pending status.
                            </p>
                        </div>
                        <br />
                        <div>
                            <table class="table list-table description-table tbModal" style="width: auto;">
                                <thead>
                                    <tr>
                                        <th scope="col" style="width: 200px;">REFERENCE</th>
                                        <th scope="col" style="width:62%">STOCK DESCRIPTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let updateditem of updatedItems">
                                        <td class="bold-text text-red padding-left" style="width: 200px;">
                                            {{ updateditem.subscriptionDescription }}</td>
                                        <td class="table-text padding-left">{{ updateditem.stockDescription }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <br />
                        <div>
                            <button class="btn btn-long btn-middle" data-dismiss="modal">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<router-outlet></router-outlet>